import { PortHoliday } from "modules/PortHolidays/usePortHolidayAPI"
import moment from "moment"
import { Table } from "react-bootstrap"

export function getFootnote({
  portHolidays,
  date,
}: {
  portHolidays: PortHoliday[] | undefined
  date: Date
}) {
  const holidaysInView =
    portHolidays &&
    getHolidaysInMonth({ viewedDate: date, holidays: portHolidays })
  const hasNonBimcoHolidays = holidaysInView?.some(
    (obj) => obj.source !== "bimco"
  )

  return (
    <div>
      <div
        className="ps-1 pe-1 pt-2 pb-2 PortPredictor_DatePicker_Legend  border-top border-1
      "
      >
        <div className="d-flex align-items-center">
          <span className="PortPredictor_DatePicker_Legend_EtaEtd me-1"></span>
          <span>ETA/ETD</span>
        </div>
        <div className="d-flex align-items-center">
          <span className="PortPredictor_DatePicker_Legend_Laycan me-1"></span>
          <span>Laycan</span>
        </div>
        <div className="d-flex align-items-center">
          <span className="PortPredictor_DatePicker_Legend_Holiday me-1"></span>
          <span>Holiday</span>
        </div>
      </div>
      {holidaysInView && holidaysInView.length > 0 && (
        <div className="container mt-1">
          <h5>Holiday Schedule</h5>
          <Table striped className="PortPredictor_HolidayTable">
            <thead>
              <tr>
                <th>Date</th>
                <th>Holiday</th>
                <th>Type</th>
                <th>Remarks</th>
                <th>Source</th>
              </tr>
            </thead>
            <tbody>
              {holidaysInView.map((holiday, index) => {
                const start = moment(holiday.start_date, "YYYY-MM-DD")
                const end = moment(holiday.end_date, "YYYY-MM-DD")
                const isStartEndSame = start.isSame(end, "day")
                return (
                  <tr key={index}>
                    <td>
                      <span className="me-1">{start.format("DD MMM")}</span>
                      {!isStartEndSame && <span>- {end.format("DD MMM")}</span>}
                    </td>
                    <td>{holiday.name}</td>
                    <td>{holiday.holiday_scope}</td>
                    <td>{holiday.remarks}</td>
                    <td>{holiday.source}</td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </div>
      )}

      {hasNonBimcoHolidays && (
        <div className="PortPredictor_DatePicker_Footnote">
          Non-BIMCO: Please confirm with agent
        </div>
      )}
    </div>
  )
}

export function getHolidaysInMonth({
  viewedDate,
  holidays,
}: {
  viewedDate: Date
  holidays: PortHoliday[]
}) {
  const startOfCalendar = moment(viewedDate).startOf("month").startOf("week")
  const endOfCalendar = moment(viewedDate).endOf("month").endOf("week")

  const filtered = holidays
    .filter((holiday) => {
      const holidayStart = moment(holiday.start_date)
      const holidayEnd = moment(holiday.end_date)

      return (
        holidayStart.isBetween(startOfCalendar, endOfCalendar, "day", "[]") ||
        holidayEnd.isBetween(startOfCalendar, endOfCalendar, "day", "[]")
      )
    })
    .sort((a, b) => {
      const startA = moment(a.start_date)
      const startB = moment(b.start_date)

      // Sort by start_date, or if equal, by end_date
      return startA.isSame(startB)
        ? moment(a.end_date).diff(moment(b.end_date))
        : startA.diff(startB)
    })

  return filtered
}
